import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrl: './version.component.less'
})
export class VersionComponent implements OnInit {

  currentVersion: string = "";
  buildDate: any = {};
  constructor() { }

  ngOnInit(): void {
    this.currentVersion = "vGeneric-Merchant-Portal-1.2.2";
    this.buildDate = new Date('2026-04-16');
  }
}
